import { ValueEditorLocation, ValueEditorLocationProps, ValueEditorProps } from '@procureai/query-builder-ui-mui';
import { useTranslation } from 'react-i18next';

import { appConfig } from '~/common/config';
import { useConfig } from '~/components/ConfigProvider';

export const LocationValueAutocomplete = ({
  ...otherProps
}: ValueEditorProps & Omit<ValueEditorLocationProps, 'at' | 'apiKey'>) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'QueryBuilder.value' });
  const { tenant } = useConfig();
  return (
    <ValueEditorLocation
      {...otherProps}
      placeholder={t('location')}
      apiKey={appConfig.location.apiKey}
      at={{ lat: tenant.geo.latitude, lng: tenant.geo.longitude }}
    />
  );
};
